import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { 
  IonFab, 
  IonFabButton, 
  IonFabList, 
  IonIcon 
} from '@ionic/angular/standalone';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../core/auth.service';

@Component({
    selector: 'fab-account',
    templateUrl: './fab-account.html',
    styleUrls: ['./fab-account.scss'],
    standalone: true,
    imports: [
      CommonModule, 
      IonFab, 
      IonFabButton, 
      IonFabList, 
      IonIcon,
      RouterLink
    ]
})
export class FabAccountComponent implements OnInit {

  constructor(
    public auth: AuthService,
  ) {}

  ngOnInit() {
  }

}
